import { createSlice } from '@reduxjs/toolkit';

const tabSlice = createSlice({
  name: 'tab',
  initialState: {
    tabName: '', 
  },
  reducers: {
    setTabName: (state, action) => {
      state.tabName = action.payload;
    },
  },
});

export const { setTabName } = tabSlice.actions;
export default tabSlice.reducer;
